// extracted by mini-css-extract-plugin
export var deleteIcon = "_mf-5";
export var deleteOption = "_mf-3";
export var divider = "_mf-2";
export var downloadIcon = "_mf-4";
export var drawer = "_mf-0";
export var drawerFooter = "_mf-6";
export var drawerOpen = "_mf-1";
export var highlighted = "_mf-7";
export var lighterHighlight = "_mf-8";